import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import { Paginator } from 'primereact/paginator';
import Warning from '../images/warning.png';
import Loader from '../components/loader';


function App() {
    const [productData, setData] = useState(null);
    const [loader, setLoader] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [first, setFirst] = useState(0); 
    const [rows, setRows] = useState(5); 
    const [showPopup, setShowPopup] = useState(false);
    const [pendingOrderId, setPendingOrderId] = useState(null);
    const [filtered, setFiltered] = useState(null);
    
    const fetchData = async (offset) => {
        setLoader(true);
        setFirst(offset);
        setRows(5);
        setSearchQuery('');
        setFiltered(null);
        setData(null);
      try {
        const  response = await axios.get('https://api.trucoo.in/product/allproduct/');
        setData(response.data.data);
        setFiltered(response.data.data);
        } catch (error) {
            console.error(error);
        }
        setLoader(false);
    };

    
    useEffect(() => {
      fetchData(0);
    }, []); 

           
    const handleSearchInputChange = (event) => {
      const query = event.target.value;
      setSearchQuery(query);

      const filtered = productData?.filter(product =>
        product.productCode.toLowerCase().includes(query.toLowerCase()) ||
        product.productName.toLowerCase().includes(query.toLowerCase())
      );

      setFiltered(filtered);
    };

    console.log(productData);
           
    const onPageChange = (event) => {
      setFirst(event.first);
    };

    const confirmRemoveOrder = (orderId) => {
      setPendingOrderId(orderId);
      setShowPopup(true);
    };
  
    const cancelRemoveOrder = () => {
      setShowPopup(false);
      setPendingOrderId(null);
    };

    const handleChangeDelete = async () => {
      const response = await axios.post('https://api.trucoo.in/product/editproduct/', { action: 'delete', id: pendingOrderId, value: 'yes' });
      fetchData();
      setShowPopup(false);
		  setPendingOrderId(null);
    };

    const handleChangeActive = async (productId, deletees) => {
      let deletes = null;
      if (deletees === 'no') {
        deletes = 'yes';
      } else {
        deletes = 'no';
      }
      const response = await axios.post('https://api.trucoo.in/product/editproduct/', { action: 'active', id: productId, value: deletes });
      fetchData();
    };

  return(
  <>
  {loader && <Loader /> }
    <div class="overlay" style={{display: showPopup ? 'flex' : 'none'}}>
    	<div class="popup">
			<img src={Warning} width='90px' />
			<h4 class="text-bold mt-2 mb-2">Delete Product</h4>
      		<p>Would you like to delete this Product?</p>
			<button class="btn btn-success mx-3" onClick={handleChangeDelete}><i class="fa fa-trash"></i></button>
      		<button class="btn btn-danger mx-3"  onClick={cancelRemoveOrder} ><i class="fa fa-close"></i></button>
    	</div>
  	</div>

    <Header />
    <Sidebar />

    <div class="content-wrapper">
		  <div class="container-full">
			  <section class="content">
            <div class="box">
				      <div class="box-header with-border">
                <h4 class="box-title">Products</h4>
				      </div>
				
				      <div class="box-body"> 
                <div class="row"> 
                  <div class="col-lg-3 mb-4" align="right">
                    <input class="form-control" placeholder="Search By Product Name or Product code" value={searchQuery} onChange={handleSearchInputChange} />
                  </div>
                  <div class="col-lg-9 mb-4" align="right">
                  <a href="/addproduct" class="waves-effect waves-light btn mb-5 bg-gradient-info" style={{float: "right"}}>Add Product</a>
                  </div>
                  <div class="col-lg-12">
					          <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 300px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                      <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-12" id="printableArea" width='100%'>
                        <thead>
                          <tr class="text-dark">
                            <th>S.No</th>
                            <th>Product Code</th>
                            <th>Product Type</th>
                            <th>Product Name</th>
                            <th>Product Price</th>
                            <th>Product Gst %</th>
                            <th>Product Weight</th>
                            <th>HSN Code</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filtered?.map((product, index) =>
                            <tr key={index}>
                              <td class="text-dark">{index + 1}</td>
                              <td class="text-dark">{product.productCode}</td>
                              <td>{product.type.toUpperCase()}</td>
                              <td >{product.productName}</td>
                              <td >₹{Number(product.productPrice).toFixed(2)}</td>
                              <td >{product.productGst}%</td>
                              <td >{parseFloat(product.productWeight)/1000} {product.unit}</td>
                              <td >{product.productHsn}</td>
                              <td class="text-center" style={{display: "flex", gap: "10px"}}>
                                <a class={`waves-effect waves-circle  btn-circle ${product.active === 'no' ? 'btn-warning': 'btn-success'}`} onClick={() => handleChangeActive(product.id, product.active)}>
                                  <i class={`fa ${product.active === 'yes' ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                </a>
                                <a href={`editproduct?id=${product.id}`}class="waves-effect waves-circle  btn-circle btn-primary">
                                  <i class="fa fa-edit"></i>
                                </a>
                                <a class="waves-effect waves-circle  btn-circle btn-danger " onClick={() => confirmRemoveOrder(product.id)}>
                                  <i class="fa fa-trash"></i>
                                </a>
                              </td>
                            </tr>
                          )}
                        </tbody>	
                      </table>
                      {/* <Paginator className="custom-paginator" first={first} rows={rows} totalRecords={filtered?.length}  onPageChange={onPageChange} /> */}
					          </div>              
				          </div>
				        </div>
			        </div>
            </div>
			    </section>
		    </div>
	    </div>
    </>
  );
}

export default App;